var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../../../shared/configure-component-base';
import { AutoRenameTypeEnum } from '../auto-rename-type-enum';
import { finalize } from 'rxjs/operators';
var RenameVariableModalComponent = /** @class */ (function (_super) {
    __extends(RenameVariableModalComponent, _super);
    function RenameVariableModalComponent(injector, variableService, bsModalRef) {
        var _this = _super.call(this, injector) || this;
        _this.variableService = variableService;
        _this.bsModalRef = bsModalRef;
        _this.importEvent = new EventEmitter();
        _this.active = false;
        _this.importing = false;
        _this.enumAutoRenameType = AutoRenameTypeEnum;
        _this.selectedRenameRule = AutoRenameTypeEnum.NameGroupNameDataSourceName;
        return _this;
    }
    RenameVariableModalComponent.prototype.import = function () {
        var _this = this;
        this.importing = true;
        this.variableService.batchImportVariablesFromFBoxVariable({
            configureId: this.configureId,
            dataSourceId: this.dataSource.id,
            dataSourceName: this.dataSource.displayName,
            refVariableIdList: this.refVariableIdList,
            renameType: +this.selectedRenameRule
        })
            .pipe(finalize(function () { return _this.importing = false; }))
            .subscribe(function () {
            _this.notify.info(_this.lc('ImportSuccessfully'));
            _this.close();
            _this.importEvent.emit();
        });
    };
    RenameVariableModalComponent.prototype.close = function () {
        this.bsModalRef.hide();
    };
    __decorate([
        Output()
    ], RenameVariableModalComponent.prototype, "importEvent", void 0);
    __decorate([
        Input()
    ], RenameVariableModalComponent.prototype, "configureId", void 0);
    RenameVariableModalComponent = __decorate([
        Component({
            selector: 'rename-variable-modal',
            template: "<div class=\"modal-content fe-modal-container\" bs-modal-drag> <form #renameForm=\"ngForm\" novalidate (ngSubmit)=\"import()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"modal-title fe-modal-header-title\"> <span>{{lc(\"AutoVariableRename\")}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"modal-body\"> <div class=\"rule-tips\"> <label>{{lc('AutoVariableRenameRule')}}</label> </div> <div class=\"rule-select\"> <label>{{lc('ConfigureVariableName')}}</label> <span> = </span> <select name=\"renameRule\" [(ngModel)]=\"selectedRenameRule\"> <option [ngValue]=\"enumAutoRenameType.NameGroupNameDataSourceName\" selected> {{lc('NameGroupNameDataSourceName')}}</option> <option [ngValue]=\"enumAutoRenameType.AutoIncrement\">{{lc('VariableNameAutoIncrease')}} </option> </select> </div> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!renameForm.form.valid||importing\" [buttonBusy]=\"importing\" [busyText]=\"l('SavingWithThreeDot')\" (click)=\"import()\"> {{lc(\"Confirm\")}} </button> <button [disabled]=\"importing\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> ",
            styles: [".modal-body { padding-left: 50px; .rule-tips { margin-bottom: 12px; } .rule-select { display: inline-block; vertical-align: middle; height: 31px; label { height: 20px; } select { height: 31px; } } } input, select { color: rgba(0, 0, 0, 0.6); } option { color: rgba(0, 0, 0, 0.6) } .fe-modal-container .fe-modal-header { border-bottom: 1px solid #f4f4f4; .fe-modal-header-title { line-height: 50px; } } "],
        })
    ], RenameVariableModalComponent);
    return RenameVariableModalComponent;
}(ConfigureComponentBase));
export { RenameVariableModalComponent };
